import type { Ref } from 'vue'
import type { FormError } from '..'
import { computed, inject } from 'vue'
import { formFieldInjectionKey, getFormError } from '..'

interface Props {
  name?: string
  error?: string | boolean
}

/**
 * Gets error-related properties
 *
 * Can be used in both form fields and form inputs
 *
 * @param props
 */
export function useFormError(props?: Props) {
  const formField = inject(formFieldInjectionKey, undefined)
  const formErrors = inject<Ref<FormError[]> | null>('form-errors', null)

  return {
    error: computed(() => props?.error || getFormError(formErrors, props?.name ?? formField?.value.name)),
  }
}
